import React, { useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Spin } from "antd";
import { Form, Input } from "antd";
import Papa from "papaparse";
import PropTypes from "prop-types";

const ScenarioEditorModal = (props) => {
  const [loading, setLoading] = useState(false);
  // const [loadingTip, setLoadingTip] = useState("Loading...");
  const handleVideoUpload = (event) => {
    if (event.target.files[0] !== undefined) {
      props.setVideoName(event.target.files[0].name);
    }
  };

  const handleRetrospectiveFrameUpload = (event) => {
    if (event.target.files[0] !== undefined) {
      setLoading(true);
      let input = event.target;
      let files = [];
      [...input.files].forEach((file) => {
        files.push(file);
      });
      const pattern = /.jpg|.jpeg|.png|.mp4/i;
      files = filterFiles(files, pattern);
      let data = sortFiles(files);
      console.log(data.length);
      props.setRetrospectiveFrameSrc(data);
      let filereader = new FileReader();
      filereader.addEventListener(
        "load",
        function () {
          if (this.result) {
            props.setSource(this.result);
            setLoading(false);
          }
        },
        false
      );
      filereader.readAsDataURL(data[0]);
    }
  };

  const handleCsvUpload = (event) => {
    if (event.target.files[0] !== undefined) {
      setLoading(false);
      Papa.parse(event.target.files[0], {
        header: true,
        complete: (results) => {
          let timestamp_data = results.data[0].Timestamp;
          let timestamps_data = [];
          let data = {};
          data["vehDetails"] = {};
          data["bew"] = { 0: null };
          let prevTime = -1;
          //let maxExtInputCmd = 0;
          for (let i = 0; i < results.data.length - 1; i++) {
            let ts = results.data[i].Timestamp - timestamp_data;
            if (
              Math.round(ts, 2) === Math.round(Math.round(ts * 30) / 30, 2) &&
              Math.round(ts * 30) / 30 !== prevTime
            ) {
              prevTime = Math.round(ts * 30) / 30;
              if (prevTime === parseInt(prevTime)) {
                prevTime = parseInt(prevTime);
              }
              timestamps_data.push(prevTime);
              try {
                //if(maxExtInputCmd < results.data[i].ExternalInputCommandPropBF0){
                //maxExtInputCmd = results.data[i].ExternalInputCommandPropBF0
                //}
                data["vehDetails"][prevTime] = {
                  timestamp: results.data[i].Timestamp,
                  event_time: results.data[i].Time,
                  speed: results.data[i].VehicleSpeed,
                  yawrate: results.data[i].YawRate,
                  long_accelaration: results.data[i].LongitudinalAccelaration,
                  lateral_accelaration: results.data[i].LateralAcceleration,
                  steering_wheel_angle: results.data[i].SteeringWheelAngle,
                  lka_right_status: results.data[i].LKARightStatus,
                  lka_left_status: results.data[i].LKALeftStatus,
                  updated_timestamp: results.data[i].Time,
                  ext_input_cmd: results.data[i].ExternalInputCommandPropBF0,
                  lane_width: results.data[i].LaneWidth,
                  vehicle_position: results.data[i].LaneVehiclePosition,
                  right_lane: results.data[i].RightLane,
                  left_lane: results.data[i].LeftLane,
                  ldw_right: results.data[i].LDWRight,
                  ldw_left: results.data[i].LDWLeft,
                  max_ext_input_cmd: results.data[i].MaxExtInputCmd,
                };
              } catch (error) {
                console.error(error);
              }
            }
          }
          props.timeline.current = timestamps_data;
          props.setDuration(props.timeline.current.length);
          props.dispatch({
            type: "new",
            payload: data,
          });
          setLoading(false);
        },
      });
    }
  };

  const onTitleChange = (e) => {
    props.setUserName(e.target.value);
  };

  const filterFiles = (files, pattern) => {
    let filteredfiles = [];
    [...files].forEach((file) => {
      if (file.name.search(pattern) !== -1) {
        filteredfiles.push(file);
      }
    });
    return filteredfiles;
  };

  const sortFiles = (files) => {
    files.sort((fileA, fileB) => {
      return parseInt(fileA.name) - parseInt(fileB.name);
    });
    return files;
  };
  //const { handleSubmit } = this.props;
  //const isEnabled = this.isSubmitEnabled();
  return (
    <div>
      <Modal isOpen={!!props.editSelectedRow} style={{ background: "blue" }}>
        <Spin spinning={loading}>
          <ModalHeader
            toggle={props.handleEditModalClose}
            style={{ color: "blue" }}
          >
            Input Files
          </ModalHeader>
          <ModalBody style={{ background: "lightgray" }}>
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-12">
                    <Form.Item label="User Name">
                      <Input onChange={(e) => onTitleChange(e)} />
                    </Form.Item>
                    <li
                      className="nav-link"
                      style={{
                        position: "relative",
                        color: "#464646",
                        cursor: "pointer",
                      }}
                    >
                      Upload Video
                      <input
                        type="file"
                        accept="video/mp4"
                        onChange={handleVideoUpload}
                        style={{
                          position: "absolute",
                          width: "100%",
                          height: "100%",
                          paddingLeft: "99px",
                          cursor: "pointer",
                        }}
                      />
                    </li>
                    <li
                      className="nav-link"
                      style={{
                        position: "relative",
                        color: "#464646",
                        cursor: "pointer",
                      }}
                    >
                      Murphy combined Frames
                      <input
                        // directory=""
                        webkitdirectory=""
                        type="file"
                        onChange={handleRetrospectiveFrameUpload}
                        style={{
                          position: "absolute",
                          width: "100%",
                          height: "100%",
                          cursor: "pointer",
                        }}
                      />
                    </li>
                    <li
                      className="nav-link"
                      style={{
                        position: "relative",
                        color: "#464646",
                        cursor: "pointer",
                      }}
                    >
                      Upload CSV
                      <input
                        type="file"
                        accept=".csv"
                        onChange={handleCsvUpload}
                        style={{
                          position: "absolute",
                          width: "100%",
                          height: "100%",
                          paddingLeft: "111px",
                          cursor: "pointer",
                        }}
                      />
                    </li>
                  </div>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              style={{ backgroundColor: "blue" }}
              onClick={props.handleEditModalClose}
            >
              Submit
            </Button>
          </ModalFooter>
        </Spin>
      </Modal>
    </div>
  );
};

ScenarioEditorModal.propTypes = {
  setVideoName: PropTypes.string,
  setRetrospectiveFrameSrc: PropTypes.array,
  setSource: PropTypes.string,
  timeline: PropTypes.shape({
    current: PropTypes.shape({
      length: PropTypes.number,
    }),
  }),
  setDuration: PropTypes.number,
  dispatch: PropTypes.object,
  setUserName: PropTypes.string,
  editSelectedRow: PropTypes.bool,
  handleEditModalClose: PropTypes.func,
};

export default ScenarioEditorModal;
